// Ganchos de lectura de la interna. Los volúmenes de V1 son chicos (cientos de filas):
// se trae todo y se filtra en el navegador. Cuando crezca, pasar filtros al servidor.
import { useGetList } from "ra-core";
import type {
  Anuncio,
  Aviso,
  Candidato,
  Cliente,
  MetricaDiaria,
  Pago,
  SolicitudCambio,
  UsuarioPortal,
  Vacante,
} from "@/reclutamiento/tipos";

const TODO = { pagination: { page: 1, perPage: 5000 } } as const;

export function useTodos<T>(recurso: string, sort = { field: "id", order: "ASC" as "ASC" | "DESC" }) {
  const r = useGetList(recurso, { ...TODO, sort });
  return { ...r, data: (r.data ?? []) as unknown as T[] };
}

export const useClientes = () => useTodos<Cliente>("clientes", { field: "nombre", order: "ASC" });
export const useVacantes = () => useTodos<Vacante>("vacantes");
export const useCandidatos = () => useTodos<Candidato>("candidatos", { field: "recibido_en", order: "DESC" });
export const usePagos = () => useTodos<Pago>("pagos", { field: "vence", order: "DESC" });
export const useAnuncios = () => useTodos<Anuncio>("anuncios", { field: "codigo", order: "ASC" });
export const useUsuariosPortal = () => useTodos<UsuarioPortal>("usuarios_portal");
export const useAvisos = () => useTodos<Aviso>("avisos", { field: "creado_en", order: "DESC" });
export const useSolicitudes = () => useTodos<SolicitudCambio>("solicitudes_cambio", { field: "creada_en", order: "DESC" });
export const useMetricas = () => useTodos<MetricaDiaria>("metricas_diarias", { field: "fecha", order: "ASC" });

/** Liga del portal «como el cliente» (misma instalación, otra entrada). */
export function ligaVerComo(clienteId: string): string {
  const base = window.location.pathname.replace(/[^/]*$/, "");
  return `${base}portal.html?ver_como=${encodeURIComponent(clienteId)}`;
}
